import React, { FunctionComponent } from 'react';
import ErrorView from 'components/ErrorView';
import useCommon from 'hooks/useCommon';
import useNavigator from 'hooks/useNavigator';

const NotAvailable: FunctionComponent = () => {
  const { title } = useCommon();
  const { navigateCallback } = useNavigator();

  return (
    <ErrorView
      title="The information you are looking for is not available."
      message={
        'The information may have been deleted, archived, or you do not have access to view it.'
      }
      actionTitle={title}
      onClick={navigateCallback('/')}
    />
  );
};

export default NotAvailable;
